import { useState, useEffect, useCallback } from 'react';

export interface VendedorSimples {
  id: string;
  nome: string;
  email?: string;
  ativo: boolean;
}

/**
 * Hook customizado para buscar lista simples de vendedores (apenas id, nome, email, ativo)
 * Usado principalmente em selects e formulários
 */
export function useVendedoresSimples() {
  const [vendedores, setVendedores] = useState<VendedorSimples[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchVendedores = useCallback(async () => {
    try {
      setLoading(true);

      // Fazer requisição para a API específica de vendedores simples
      const response = await fetch('/api/parceiros/vendedores', {
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Erro ao buscar vendedores');
      }

      const data: VendedorSimples[] = await response.json();

      if (import.meta.env.DEV) {
        console.log('🔍 useVendedoresSimples - Vendedores carregados:', data);
      }

      setVendedores(data);
      setError(null);
    } catch (err) {
      console.error('Erro ao buscar vendedores:', err);
      setError(err instanceof Error ? err.message : 'Erro desconhecido');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchVendedores();
  }, [fetchVendedores]);

  return { vendedores, loading, error, refetch: fetchVendedores };
}
